import api from "../../services/api";

const APIS = {
    SIGN_IN: "/auth/login",
    UPDATE_PASSWORD: "/auth/update-password",
    FORGOT_PASSWORD: "/auth/forgot-password"
};

export const signInUser = async (credentials) => {
    try {
        const requestBody = {
            userEmail: credentials.userEmail?.trim().toLowerCase() || "",
            password: credentials.password,
            recaptchaToken: credentials.recaptchaToken,
        };
        const res = await api.post(APIS.SIGN_IN, requestBody);
        if (res.data && res.data.access_token) {
            return {
                success: true,
                token: res.data.access_token,
                tokenType: res.data.token_type || "Bearer",
                expiresIn: res.data.expires_in || 28800,
                data: res.data
            };
        } else {
            return {
                success: false,
                error: "Invalid response format"
            };
        }
    } catch (error) {
        console.error("Login API error:", error);
        console.error("Error response:", error.response);

        if (error.response?.status === 401) {
            return {
                success: false,
                error: "Invalid credentials"
            };
        } else if (error.response?.status === 404) {
            return {
                success: false,
                error: "Authentication service not found"
            };
        }

        return {
            success: false,
            error: error.response?.data?.message || error.message || "Sign in failed"
        };
    }
};

export const updatePassword = async (passwordData) => {
    try {
        const requestBody = {
            activationCode: passwordData.activationCode,
            password: passwordData.password
        };

        const res = await api.post(APIS.UPDATE_PASSWORD, requestBody);

        return {
            success: true,
            message: "Password updated successfully",
            data: res.data
        };
    } catch (error) {
        console.error("Update password API error:", error);
        console.error("Error response:", error.response);

        if (error.response?.status === 400) {
            return {
                success: false,
                error: "Invalid activation code or password"
            };
        } else if (error.response?.status === 404) {
            return {
                success: false,
                error: "Activation code not found or expired"
            };
        } else if (error.response?.status === 422) {
            return {
                success: false,
                error: "Password does not meet requirements"
            };
        }

        return {
            success: false,
            error: error.response?.data?.message || error.message || "Password update failed"
        };
    }
};

export const forgotPassword = async (email) => {
    try {
        const res = await api.post(APIS.FORGOT_PASSWORD, email?.trim().toLowerCase() || "");
        return {
            success: true,
            message: "Reset link sent successfully",
            data: res.data
        };
    } catch (error) {
        console.error("Forgot password API error:", error);
        console.error("Error response:", error.response);

        if (error.response?.status === 404) {
            return {
                success: false,
                error: "Email not found"
            };
        } else if (error.response?.status === 400) {
            return {
                success: false,
                error: "Invalid email format"
            };
        }

        return {
            success: false,
            error: error.response?.data?.message || error.message || "Failed to send reset link"
        };
    }
};
